<template lang="pug">
    include DashboardAddresses.pug
</template>

<script>
import _ from "underscore";
import Api from "@/components/services/Api";

export default {
  name: 'DashboardAddresses',
  data() {
    return {
      user: {
        first_name: null,
        last_name: null,
        phone: null,
        gender: null,
        address: null,
        address2: null,
        zip_code: null,
        administrative_zone: null,
        city: null,
      },
      showFormPersonal: false,
      showFormAddress: false,
      showFormCredentials: false,
      showFormPhoto: false,
      password: "",
      password2: "",
      token: null,
      image: null,
    }
  },
  computed: {
    currentUrl: function() {
      return window.location.href.split("#")[0];
    },
    avatarAction: function() {
      return Api.getApiUrl() + "/esreps/avatar-update/";
    }
  },
  created() {
    const _this = this;
    this.token = this.$store.state.token;

    Api.me(this.$store.state.token).then(response => {
      _this.user.first_name = response.data.first_name
      _this.user.last_name = response.data.last_name
      _this.user.phone = response.data.phone
      _this.user.gender = response.data.gender
      _this.user.email = response.data.email
      _this.user.zip_code = response.data.zip_code
      _this.user.address = response.data.address
      _this.user.address2 = response.data.address2
      _this.user.city = response.data.city
      _this.user.administrative_zone = response.data.administrative_zone

      _this.image = _this.user.image
    }).catch(err => {
    });
  },
  filters: {
    genderhuman(value) {
      let map = {
        male: "Hombre",
        female: "Mujer",
        other: "Otro",
      }

      if (map.hasOwnProperty(value)) return map[value];
      return value;
    }
  },
  methods: {
    saveAddressData() {
      const _this = this

      let partialData = {
        address: this.user.address,
        address2: this.user.address2,
        zip_code: this.user.zip_code,
        city: this.user.city,
        administrative_zone: this.user.administrative_zone,
      }

      Api.userPartialUpdate(partialData, this.$store.state.token).then(response => {
        _this.$notify({
          group: "esreps",
          title: "Datos actualizados",
          type: "success",
          text: "Se han actualizados los datos correctamente en la base de datos"
        });
      }).catch(err => {
      })
    },
    savePersonalData() {
      const _this = this
      let partialData = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        phone: this.user.phone,
        gender: this.user.gender,
        email: this.user.email,
      }

      Api.userPartialUpdate(partialData, this.$store.state.token).then(response => {
        _this.$notify({
          group: "esreps",
          title: "Datos actualizados",
          type: "success",
          text: "Se han actualizados los datos correctamente en la base de datos"
        });
      }).catch(err => {
      })
    },
    save() {
      const _this = this;
      if (!this.showFormPersonal && !this.showFormAddress && !this.showFormCredentials) return true;

      // Check password consistency
      if (this.showFormCredentials) {
        if (!this.password.length || !this.password2.length || (this.password != this.password2)) {
          _this.$notify({
            group: "esreps",
            title: "Error",
            type: "warn",
            text: "Las contraseñas deben coincidir"
          });
        }
      }

      let postObject = {}

      if (this.showFormPersonal) {
        postObject = _.extend(postObject, {
          first_name: this.user.first_name,
          email: this.user.email,
          last_name: this.user.last_name,
          cell_phone: this.user.cell_phone,
          phone: this.user.phone,
          gender: this.user.gender,
          foreign_language: this.user.foreign_language,
        });
      }

      if (this.showFormAddress) {
        postObject = _.extend(postObject, {
          address: this.user.address,
          city: this.user.city,
          zip_code: this.user.zip_code,
          administrative_zone: this.user.administrative_zone,
        });
      }

      if (this.showFormCredentials) {
        postObject.password = this.password;
      }

      Api.updateUser(postObject, this.$store.state.token).then(response => {
        _this.$notify({
          group: "esreps",
          title: "Mensaje",
          text: "Los cambios del formulario se han guardado correctamente"
        });
        _this.showFormPersonal = false;
        _this.showFormAddress = false;
        _this.showFormCredentials = false;
      }).catch(err => {
      });
    }
  }
}
</script>

<style scoped lang="scss">
@import "./../../styles/common_forms";
@import "Dashboard";
@import "DashboardAddresses";
</style>




// WEBPACK FOOTER //
// src/components/dashboard/DashboardAddresses.vue